"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidateAnswerViewModel = candidateAnswerViewModel;
function candidateAnswerViewModel(answer) {
    return {
        ...answer,
        respondent: answer.respondent ?? "candidate",
    };
}
